// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/projects.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/projects.tsx");
  import.meta.hot.lastModified = "1716289823162.785";
}
// REMIX HMR END

import { Link } from "@remix-run/react";
export const meta = () => [{
  title: "Projects | Tom Frantz"
}, {
  name: "description",
  content: "All the projects, created by Tom Frantz"
}];
export default function ProjectsPage() {
  return <div className=" px-2 py-16 text-black sm:px-8 ">
      <div className="mx-auto flow-root w-full max-w-2xl gap-16 lg:max-w-5xl">
        <h2 className="text-3xl font-bold">Me, Myself, and I</h2>
        <div className="mt-12 grid grid-cols-2 gap-12">
          {[0, 1].map(i => <article key={i} className="rounded-2xl border-4 border-lothian-blue p-2">
              <h3 className="text-xl font-semibold">Polonnaruwa</h3>
              <p className="text-sm">A game about the coconut people</p>
              {/*<img src={} />*/}
              <Link to={"/blog/polonnaruwa-0"}>Latest post</Link>
            </article>)}
        </div>
      </div>
    </div>;
}
_c = ProjectsPage;
var _c;
$RefreshReg$(_c, "ProjectsPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;